// extracted by mini-css-extract-plugin
module.exports = {"body":"SelectYear-module__body--2JPiL","container":"SelectYear-module__container--kA3HG","title":"SelectYear-module__title--3vPzS"};